/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MemberPointsResponse model module.
 * @module model/MemberPointsResponse
 * @version v1
 */
class MemberPointsResponse {
    /**
     * Constructs a new <code>MemberPointsResponse</code>.
     * @alias module:model/MemberPointsResponse
     * @param loyaltyBalance {Number} 
     * @param linkedPointsBalance {Number} 
     */
    constructor(loyaltyBalance, linkedPointsBalance) { 
        
        MemberPointsResponse.initialize(this, loyaltyBalance, linkedPointsBalance);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, loyaltyBalance, linkedPointsBalance) { 
        obj['LoyaltyBalance'] = loyaltyBalance;
        obj['LinkedPointsBalance'] = linkedPointsBalance;
    }

    /**
     * Constructs a <code>MemberPointsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MemberPointsResponse} obj Optional instance to populate.
     * @return {module:model/MemberPointsResponse} The populated <code>MemberPointsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MemberPointsResponse();

            if (data.hasOwnProperty('LoyaltyBalance')) {
                obj['LoyaltyBalance'] = ApiClient.convertToType(data['LoyaltyBalance'], 'Number');
            }
            if (data.hasOwnProperty('LinkedPointsBalance')) {
                obj['LinkedPointsBalance'] = ApiClient.convertToType(data['LinkedPointsBalance'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MemberPointsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MemberPointsResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of MemberPointsResponse.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

MemberPointsResponse.RequiredProperties = ["LoyaltyBalance", "LinkedPointsBalance"];

/**
 * @member {Number} LoyaltyBalance
 */
MemberPointsResponse.prototype['LoyaltyBalance'] = undefined;

/**
 * @member {Number} LinkedPointsBalance
 */
MemberPointsResponse.prototype['LinkedPointsBalance'] = undefined;






export default MemberPointsResponse;

